import * as angular from 'angular';
import permissions from 'application/detail/permissions.json';
import { ActiveMessagesFeatures } from './ActiveMessagesFeatures';
import { ActiveMessagesController } from 'modules/application/detail/growth/activeMessages/ActiveMessagesController';
import ActiveMessagesView from './ActiveMessagesView.html';
import { SendActiveMessageController } from 'modules/application/detail/growth/activeMessages/sendActiveMessage/SendActiveMessageController';
import SendActiveMessageView from './sendActiveMessage/SendActiveMessageView.html';
import { GrowthSegmentService } from './../GrowthSegmentService';
import { ActiveMessageService } from './ActiveMessageService';
import { ActiveMessageTemplateCardComponent } from './../activeMessages/activeMessageTemplateCard/ActiveMessageTemplateCardController';
import { ActiveMessageItemComponent } from './activeMessageItem/activeMessageItemController';
import { AudienceStep } from './stepComponents/AudienceStepComponent/AudienceStepComponentController';
import { ContentStep } from './stepComponents/ContentStepComponent/ContentStepComponentController';
import { ResponseTargetingBuilderStep } from './stepComponents/responseTargetingStepComponent/builder/responseTargetingStepComponentBuilderController';
import { ResponseTargetingRouterStep } from './stepComponents/responseTargetingStepComponent/router/responseTargetingStepComponentRouterController';
import { SendStep } from './stepComponents/SendStepComponent/SendStepComponentController';
import { StepResume } from './stepComponents/SendStepComponent/stepResumeComponent/stepResumeComponentController';
import { ActiveMessageTemplateInputVariablesComponent } from './stepComponents/ContentStepComponent/components/variablesInputs/ActiveMessageTemplateInputVariablesController';
import { ActiveMessageTemplateDisplayVariablesComponent } from './stepComponents/ContentStepComponent/components/variablesDisplay/ActiveMessageTemplateDisplayVariablesController';
import { ActiveMessagesConstants } from './ActiveMessagesConstants';
import { EditScheduledCampaignController } from './editScheduledCampaign/EditScheduledCampaignController';
import EditScheduledCampaignView from './editScheduledCampaign/EditScheduledCampaignView.html';
import { MicroFrontendService } from 'modules/shared/MicroFrontendService';
import { activeCampaignMfeScriptSource } from 'app.constants';
export const activeMessages = angular
    .module('activeMessages', ['ui.router'])
    .service('GrowthSegmentService', GrowthSegmentService)
    .component('activeMessageTemplateCard', ActiveMessageTemplateCardComponent)
    .service('ActiveMessageService', ActiveMessageService)
    .component('activeMessageItem', ActiveMessageItemComponent)
    .component('activeMessageTemplateCardComponent', ActiveMessageTemplateCardComponent)
    .component('audienceStep', AudienceStep)
    .component('contentStep', ContentStep)
    .component('activeMessageTemplateInputVariablesComponent', ActiveMessageTemplateInputVariablesComponent)
    .component('activeMessageTemplateDisplayVariablesComponent', ActiveMessageTemplateDisplayVariablesComponent)
    .component('responseTargetingBuilderStep', ResponseTargetingBuilderStep)
    .component('responseTargetingRouterStep', ResponseTargetingRouterStep)
    .component('sendStep', SendStep)
    .component('stepResume', StepResume)
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider
            .state(ActiveMessagesConstants.ACTIVE_MESSAGE_STATE, {
            url: '/activemessages',
            views: {
                'content@auth.application.detail': {
                    template: ActiveMessagesView,
                    controller: ActiveMessagesController,
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.scheduler.claim,
            },
            params: { area: 'scheduler' },
            async onEnter() {
                if (await ActiveMessagesFeatures.isEnabledActiveCampaignMFE()) {
                    return MicroFrontendService.addSource(activeCampaignMfeScriptSource);
                }
            },
        })
            .state(ActiveMessagesConstants.SEND_ACTIVE_MESSAGE_STATE, {
            url: '/sendactivemessage?fileName?mediaUrl?applicationOrigin?',
            views: {
                'content@auth.application.detail': {
                    template: SendActiveMessageView,
                    controller: SendActiveMessageController,
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.scheduler.claim,
            },
            params: { area: 'scheduler' },
            async onEnter() {
                if (await ActiveMessagesFeatures.isEnabledActiveCampaignMFE()) {
                    return MicroFrontendService.addSource(activeCampaignMfeScriptSource);
                }
            },
        })
            .state(ActiveMessagesConstants.EDIT_SCHEDULED_CAMPAIGN_STATE, {
            url: '/editscheduledCampaign?campaignId',
            views: {
                'content@auth.application.detail': {
                    template: EditScheduledCampaignView,
                    controller: EditScheduledCampaignController,
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.scheduler.claim,
            },
            params: { area: 'scheduler' },
            async onEnter() {
                if (await ActiveMessagesFeatures.isEnabledActiveCampaignMFE()) {
                    return MicroFrontendService.addSource(activeCampaignMfeScriptSource);
                }
            },
        })
            .state('auth.application.detail.growth.activeMessages.paymentsReport', {
            url: '/paymentsReport',
            views: {
                'content@auth.application.detail': {
                    template: ActiveMessagesView,
                    controller: ActiveMessagesController,
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.scheduler.claim,
            },
            params: { area: 'scheduler' },
            async onEnter() {
                if (await ActiveMessagesFeatures.isEnabledActiveCampaignMFE()) {
                    return MicroFrontendService.addSource(activeCampaignMfeScriptSource);
                }
            },
        });
    }]).name;
